import { TableCell, TableRow } from "@mui/material";
import React from "react";
import TablePage from "../../../components/universal/TablePage";
import { GoalConfigurationForTableFragment } from "../../../types";
import { PaginationHooks } from "../../../utils/pagination";
import { AthleteGoalTableRows } from "./AthleteGoalTableRows";

interface AthleteGoalTableProps {
  paginationHooks: PaginationHooks;
  rows: readonly GoalConfigurationForTableFragment[];
  loading: boolean;
  totalRows: number;
  tableHeader: React.ReactNode;
  onRowClick?: (row: GoalConfigurationForTableFragment) => void;
}

export const AthleteGoalTable = ({ paginationHooks, loading, totalRows, rows, tableHeader }: AthleteGoalTableProps) => {
  return (
    <TablePage
      header={tableHeader}
      tableHeaderRow={
        <TableRow>
          <TableCell>Emoji</TableCell>
          <TableCell>Task</TableCell>
          <TableCell>Type</TableCell>
          <TableCell>Completion Criteria</TableCell>
          <TableCell>Start Date</TableCell>
          <TableCell>End Date</TableCell>
          <TableCell>Overall Progress</TableCell>
          <TableCell padding="checkbox">Actions</TableCell>
        </TableRow>
      }
      tableBodyRows={<AthleteGoalTableRows rows={rows} />}
      paginationHooks={paginationHooks}
      loading={loading}
      total={totalRows}
    />
  );
};
